import { createSelector } from 'reselect'

export const getHeaderBackgroundColorSelector = createSelector(
  settings => settings.HeaderBackgroundColor,
  (headerColor) => headerColor
);